<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="equipment">Fuel Out Equipment</label>
                    <input type="text" id="equipment" class="form-control" [(ngModel)]="target.equipment" name="equipment" disabled />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="costCode">Cost Code</label>
                    <input type="number" id="costCode" class="form-control" [(ngModel)]="target.costCode" name="costCode" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="costType">Cost Type</label>
                    <input type="number" id="costType" class="form-control" [(ngModel)]="target.costType" name="costType" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="offsetGl">Offset GL</label>
                    <input type="number" id="offsetGl" class="form-control" [(ngModel)]="target.offsetGl" name="offsetGl" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
